import { Show } from 'solid-js'
import { useNavigate, useLocation } from '@solidjs/router'
import { useAuth } from '../lib/auth'

export default function ModeSwitcher() {
  const auth = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  const isStaffMode = () => location.pathname.startsWith('/staff')
  const isGuestMode = () => !isStaffMode()

  return (
    <div class="bg-white border-b border-gray-200 px-4 py-2">
      <div class="max-w-md mx-auto flex items-center justify-center gap-1">
        <button
          onClick={() => { auth.switchMode('guest'); navigate('/pass') }}
          class={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
            isGuestMode()
              ? 'bg-emerald-600 text-white'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          My Pass
        </button>
        <button
          onClick={() => { auth.switchMode('staff'); navigate('/staff') }}
          class={`px-4 py-1.5 rounded-full text-sm font-medium transition-colors ${
            isStaffMode()
              ? 'bg-emerald-600 text-white'
              : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
          }`}
        >
          Staff Mode
        </button>
      </div>
    </div>
  )
}
